/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ListPerformanceQuery } from '../models/list-performance-query';
import { ListPerformanceResult } from '../models/list-performance-result';

@Injectable({
  providedIn: 'root',
})
export class PerformanceService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation performanceList
   */
  static readonly PerformanceListPath = '/api/Performance/List/List';

  /**
   * Teljesítmény listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `performanceList$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  performanceList$Plain$Response(params?: {
    body?: ListPerformanceQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListPerformanceResult>> {

    const rb = new RequestBuilder(this.rootUrl, PerformanceService.PerformanceListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListPerformanceResult>;
      })
    );
  }

  /**
   * Teljesítmény listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `performanceList$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  performanceList$Plain(params?: {
    body?: ListPerformanceQuery
  },
  context?: HttpContext

): Observable<ListPerformanceResult> {

    return this.performanceList$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListPerformanceResult>) => r.body as ListPerformanceResult)
    );
  }

  /**
   * Teljesítmény listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `performanceList()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  performanceList$Response(params?: {
    body?: ListPerformanceQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListPerformanceResult>> {

    const rb = new RequestBuilder(this.rootUrl, PerformanceService.PerformanceListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListPerformanceResult>;
      })
    );
  }

  /**
   * Teljesítmény listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `performanceList$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  performanceList(params?: {
    body?: ListPerformanceQuery
  },
  context?: HttpContext

): Observable<ListPerformanceResult> {

    return this.performanceList$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListPerformanceResult>) => r.body as ListPerformanceResult)
    );
  }

}
